import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '活动分类', path: '/category/outdoor' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const handleCategoryClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    navigate('/category/outdoor');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <span className="text-2xl font-heading text-primary-500 whitespace-nowrap">
              17c一起
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={(e) => {
                  if (link.name === '活动分类') {
                    handleCategoryClick(e);
                    return;
                  }
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className={`text-sm font-label whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  (link.path === '/' && location.pathname === '/') ||
                  (link.path !== '/' && location.pathname.startsWith(link.path))
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/about"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="bg-primary-500 text-background-50 px-5 py-2 rounded-full text-sm font-label whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              加入我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={(e) => {
                  if (link.name === '活动分类') {
                    handleCategoryClick(e);
                    return;
                  }
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className={`text-sm font-label py-2 whitespace-nowrap cursor-pointer ${
                  (link.path === '/' && location.pathname === '/') ||
                  (link.path !== '/' && location.pathname.startsWith(link.path))
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-700'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/about"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="bg-primary-500 text-background-50 px-5 py-2 rounded-full text-sm font-label text-center whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              加入我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}